import React, { useState } from "react";
import ExtensionCard from "app/popleads/components/ui-kit/ExtensionCard";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import FeatherIcon from "feather-icons-react";
import { POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import { StyledCardContent, StyledCardFooter } from "./common/styled";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import { toast } from "react-toastify";
import useEtiketEkle from "app/popleads/hooks/useEtiketEkle";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
export const StyledCampaignLinkContent = styled(StyledCardContent)`
    color: ${(props) => colors.primary[950]};
`;
const ExtensionCourseCard = () => {
    const { profile, setState, popit } = useExtensionContext();
    const [showSearchCampaign, setShowSearchCampaign] = useState(false);

    const { etiketEkle } = useEtiketEkle();
    const user = useSelector((state) => state.auth.user);

    const etiketList = profile?.etiket.map((etiket) => {
        return {
            icon: <FeatherIcon strokeWidth="1px" icon="book-open" size="16" />,
            content: (
                <a
                    href={user?.company?.companyConfig?.oldCrmPopleadsHttpLink + "/?campaignId=" + etiket?.campaignId}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledCampaignLinkContent>{etiket.metin}</StyledCampaignLinkContent>
                </a>
            ),
            footer: (
                <StyledCardFooter>
                    {etiket.campaignType} {etiket.campaignType && etiket.campaignDate ? " | " : ""}
                    {etiket.campaignDate}
                </StyledCardFooter>
            ),
        };
    });

    const handleButtonClick = () => {
        if (showSearchCampaign) {
            setShowSearchCampaign(false);
        } else {
            if (popit) {
                toast.warning("You need to POP the profile first.");
            } else {
                setShowSearchCampaign(true);
            }
        }
    };

    return (
        <>
            <ExtensionCard
                input={
                    <ExtensionCampaignSearchInput
                        label={false}
                        optionClick={(value) => {
                            etiketEkle({ profil: profile.id, etiket: value?.id });
                        }}
                    />
                }
                isShowInput={showSearchCampaign}
                button={
                    <ButtonWithText
                        icon={showSearchCampaign ? "remove" : "add"}
                        iconType="material"
                        variant="primary"
                        buttonStyle="default"
                        size="circle"
                        onClick={handleButtonClick}
                    />
                }
                cardTitle={profile?.etiket?.length > 0 ? `Campaigns (${profile?.etiket?.length})` : "Campaigns"}
                cardTitleOnClick={() => {
                    if (popit) {
                        toast.warning("You need to POP the profile first.");
                    } else {
                        setState({ popupContent: POPUP_CONTENTS.COURSES });
                    }
                }}
                cardItems={etiketList}
                viewMoreOnClick={() => {
                    setState({ popupContent: POPUP_CONTENTS.COURSES });
                }}
                minVisibleItems={0}
                errorDescription="Click the + to assign a campaign."
            />
        </>
    );
};

export default ExtensionCourseCard;
